export default {"src":"/_next/static/media/arrow_left.463b228a.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};